<template>
  <div>
    <bridge8-popover
      v-if="typeof airline === 'object'"
      :obj="airline"
      trigger="click"
      :text-callback="airline => airline.code"
      header-prefix="Airline: "
    />
    <span v-else>{{ airline }}</span>
    <span v-if="airline && airline2 && (airline2.code !== airline.code)">
      <span> - </span>
      <bridge8-popover
        v-if="typeof airline2 === 'object'"
        :obj="airline2"
        trigger="click"
        :text-callback="airline => airline.code"
        header-prefix="Second airline: "
      />
      <span v-else>{{ airline2 }}</span>
    </span>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Bridge8Popover from './Bridge8Popover'

export default {
  name: 'CalcFlightsTableCellAirline',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('calc', {
      airlines: state => state.data.airlines
    }),
    airline () {
      return this.airlines.find(airline => airline.code === this.row.airline) || this.row.airline
    },
    airline2 () {
      return this.airlines.find(airline => this.row.airline2 ? airline.code === this.row.airline2 : false) || this.row.airline2
    }
  },
  components: {
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellAirline.vue